import { BaseComponent } from '../../base-component'

export class Card extends BaseComponent {}
